import * as React from "react";
import FtContainerDesk from "../ftContainer/ftContainerDesk";
import { APayoutBankDetails, AEqMaxPayout, ACommFundLimit, AFTCommPayoutBankDetails } from "../../../service/fundTransfer/fundTransferApiService";
import "../../../../assets/scss/components/toc/fundTransfer/ftPayout/ftPayout.scss";
import { IftPayout, IftPayoutDeatils, IcommLimits } from "../../../types/components/fundTransfer/ftTypes";
import FtPayOut from "./ftPayOut/ftPayOut";
import FtContainerTab from "../ftContainer/ftContainerTab";
import FtContainerMob from "../ftContainer/ftContainerMob";
import { Idevice } from "./../../../types/device";
import DeviceContext from "./../../../service/indentifyDevice";
import { SLoader } from "../../../generic/loader";
import { parsedToken } from "../../../service/storageHelper";
import { jwtToken } from "../../../types/genericTypes";

interface IFtPayOutContProps {}

export enum EFtPayOutFormFields {
	AMOUNT = "amount",
	BANK = "bank",
	REMARKS = "remarks"
}

const FtPayOutCont: React.FunctionComponent<IFtPayOutContProps> = (props) => {
	const deviceState: Idevice = DeviceContext();
	const [inst, setInst] = React.useState(SLoader(20, "blue"));
	const pToken: jwtToken | null = parsedToken();
	const [maxpayout, setMaxpayout] = React.useState<string>("");
	const [coUserLim, setCoUserLim] = React.useState<IcommLimits>({
		colVal: "",
		lmAvl: "",
		lrB: "",
		mrUzd: "",
		piAmt: "",
		poAmt: ""
	});

	const [eqDetails, setEqDetails] = React.useState<IftPayoutDeatils>();
	const [coDetails, setCoDetails] = React.useState<IftPayoutDeatils>();

	const initObj = {
		pndPayout: false,
		payoutMntFlg: false,
		bodFlg: false,
		pendingMsg: "",
		bnkAcs: [],
		brk: "",
		type: ""
	};

	const commFundLimitRes = (res: any) => {
		if (res.data) {
			// setState({ commCash: res.data.lmt.lmAvl });
			setCoUserLim(res.data.lmt);
		}
	};

	function hndlPayoutState() {
		if (eqDetails && coDetails) {
			setInst(<FtPayOut eq={eqDetails} co={coDetails} eqCash={maxpayout} coCash={coUserLim} />);
		}
	}
	function init() {
		APayoutBankDetails(EqPayoutcallback);
		//comm account bank details
		AFTCommPayoutBankDetails(COPayoutcallback);
		AEqMaxPayout(maxpayoutCallback);
		ACommFundLimit(commFundLimitRes);

		if (pToken && pToken.accType === "CO") {
			setEqDetails(initObj);
		}
		if (pToken && pToken.accType === "EQ") {
			setCoDetails(initObj);
		}
		function maxpayoutCallback(res: any) {
			if (res.data) {
				if (res.data) {
					// setState({ eqCash: res.data.cshAvl });
					setMaxpayout(res.data.maxPytAmt);
				}
			}
		}
		function COPayoutcallback(res: any) {
			if (res.data) {
				const resp: IftPayoutDeatils = res.data as IftPayoutDeatils;
				setCoDetails(resp);
				dispatch(resp);
				if (payoutState && payoutState.details) {
					hndlPayoutState();
				}
			}
			//only for comm account
			else if (res.error) {
				const details = {
					pndPayout: true,
					payoutMntFlg: false,
					bodFlg: true,
					pendingMsg: res.error.errMsg,

					bnkAcs: [],
					brk: "",
					type: ""
				};
				setCoDetails(details);
				dispatch(details);
			}
		}
		function EqPayoutcallback(res: any) {
			if (res.data) {
				const resp: IftPayout = res.data as IftPayout;
				const details: IftPayoutDeatils = JSON.parse(resp.details) as IftPayoutDeatils;
				setEqDetails(details);
				dispatch(resp);
				if (payoutState && payoutState.details) {
					hndlPayoutState();
				}
			}
		}
		return null;
	}

	function reducer(_prevState: any, newState: any) {
		return newState;
	}

	const [payoutState, dispatch] = React.useReducer(reducer, null, init);

	React.useEffect(() => {
		hndlPayoutState();
	}, [maxpayout, coUserLim, payoutState]);

	return (
		<section className="ftSection">
			<section className="payOutCont">
				{deviceState.isDesktop ? (
					<FtContainerDesk instComp={inst} />
				) : deviceState.isTablet ? (
					<FtContainerTab instComp={inst} />
				) : (
					<FtContainerMob instComp={inst} />
				)}
			</section>
		</section>
	);
};

export default FtPayOutCont;
